import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { take } from 'rxjs';

import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class UpdateService {
  #started = false;
  #updates = inject(SwUpdate);
  #toast = inject(ToastService);

  public start(): void {
    if (!this.#updates.isEnabled || this.#started) {
      return;
    }

    this.#started = true;
    console.info('[UpdateService] Inicializado.');

    this.checkForUpdates();

    this.#updates.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.#promptUser(event);
      }
    });
  }

  public checkForUpdates(): void {
    void this.#updates
      .checkForUpdate()
      .then(() =>
        console.info('[UpdateService] Checagem manual de atualização.')
      )
      .catch((err) =>
        console.warn('[UpdateService] Falha ao checar atualização:', err)
      );
  }

  #promptUser(event: VersionReadyEvent): void {
    console.info('[UpdateService] Nova versão detectada:', event.latestVersion);
    const ref = this.#toast.info('Nova versão disponível. Atualizando...', {
      duration: 3000
    });

    ref.afterClosed.pipe(take(1)).subscribe(() => {
      this.#updates.activateUpdate().then(() => location.reload());
    });
  }
}
